import styled from "styled-components";

export const HomeScreen = styled.div`
    min-height: 100vh;
    background: ${({ theme }) => theme.palette.colors.background};
    color: ${({ theme }) => theme.palette.colors.text};
    font-family: Inter, sans-serif;
`;

export const HomeHero = styled.section`
    position: relative;
    min-height: 600px;
    display: flex;
    align-items: stretch;
    overflow: hidden;
    background: ${({ theme }) => theme.palette.colors.background};

    @media (max-width: 991px) {
        min-height: 520px;
    }
`;

export const HomeHeroImage = styled.div`
    position: absolute;
    inset: 0;
    background: ${({ image }) => image ? `url(${image}) top center / cover no-repeat` : 'transparent'};
    transform: scale(1.01);
`;

export const HomeHeroOverlay = styled.div`
    position: absolute;
    inset: 0;
    background:
        linear-gradient(90deg,
            ${({ theme }) => theme.palette.colors.background} 0%,
            ${({ theme }) => theme.palette.colors.backgroundSoft} 22%,
            ${({ theme }) => theme.palette.colors.backgroundTransparent} 100%
        ),
        linear-gradient(180deg,
            ${({ theme }) => theme.palette.colors.backgroundTransparent} 0%,
            ${({ theme }) => theme.palette.colors.backgroundTransparent} 58%,
            ${({ theme }) => theme.palette.colors.background} 100%
        );
`;

export const HomeHeroContent = styled.div`
    position: relative;
    z-index: 1;
    width: 100%;
    padding: 72px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 18px;

    @media (max-width: 991px) {
        padding: 112px 18px 44px;
        gap: 16px;
    }
`;

export const HomeEyebrow = styled.div`
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: ${({ theme }) => theme.palette.colors.subdued};
`;

export const HomeTitle = styled.h1`
    margin: 0;
    max-width: min(860px, 62vw);
    font-size: 58px;
    font-weight: 700;
    line-height: 1.07;
    letter-spacing: -0.04em;
    white-space: pre-line;

    @media (max-width: 991px) {
        max-width: 100%;
        font-size: 38px;
    }
`;

export const HomeDescription = styled.p`
    margin: 0;
    max-width: min(760px, 48vw);
    font-size: 16px;
    line-height: 1.65;
    color: ${({ theme }) => theme.palette.colors.muted};
`;

export const HomeAdditionalText = styled.div`
    width: fit-content;
    max-width: min(820px, 58vw);
    border: 1px solid ${({ theme }) => theme.palette.colors.informationPanelBorder};
    border-radius: 10px;
    padding: 18px 22px;
    background: #FFFFFF;
    box-shadow: ${({ theme }) => theme.palette.colors.informationPanelShadow};
    color: #0F172B;
    font-family: Inter, sans-serif;
    font-size: 18px;
    font-weight: 700;
    line-height: 1.5;
    white-space: pre-line;

    @media (max-width: 991px) {
        width: 100%;
        max-width: 100%;
        padding: 16px 18px;
    }
`;

export const HomeHeroButton = styled.button.attrs({
    type: "button",
})`
    width: fit-content;
    min-height: 56px;
    border: 0;
    border-radius: 10px;
    padding: 16px 40px;
    background: ${({ theme }) => theme.palette.colors.ctaBackground};
    color: ${({ theme }) => theme.palette.colors.ctaText};
    box-shadow: ${({ theme }) => theme.palette.colors.ctaShadow};
    font-family: Inter, sans-serif;
    font-size: 18px;
    font-weight: 700;
    cursor: pointer;
`;

export const HomeSections = styled.div`
    width: 100%;
    padding: 0 clamp(24px, 4vw, 72px) 72px;
    display: flex;
    flex-direction: column;
    gap: 56px;
    background: ${({ theme }) => theme.palette.colors.background};
    @media (max-width: 991px) {
        padding: 0 18px 40px;
        gap: 40px;
    }
`;

export const HomeEmptyState = styled.div`
    min-height: 220px;
    border: 1px solid ${({ theme }) => theme.palette.colors.borderSoft};
    border-radius: 20px;
    background: ${({ theme }) => theme.palette.colors.surfaceSoft};
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
    text-align: center;
    font-size: 16px;
    line-height: 1.6;
    color: ${({ theme }) => theme.palette.colors.muted};
`;
